export default ((time) => {
  const now = +new Date();
  let interval;
  let timestamp;
  let timeArr;
  let pastTimeStr = '';

  timeArr = typeof time === 'string' ? (
    time.split(/\D/).map((t, i, arr) => {
      return i === 1 ? t - 1 : t;
    })) : [];
  timestamp = (typeof time === 'string' ? +(new (Function.prototype.bind.apply(Date, [null].concat(timeArr)))) : +time);
  interval  = now - timestamp;

  if (interval < 60000) {
    pastTimeStr = '방금 전';
  } else if (interval < 3600000) {
    pastTimeStr = Math.round(interval / 60000) + '분 전';
  } else if (interval < 86400000) {
    pastTimeStr = Math.round(interval / 3600000) + '시간 전';
  } else if (interval < 604800000) {
    pastTimeStr = Math.round(interval / 86400000) + '일 전';
  } else {
    pastTimeStr = Math.round(interval / 604800000) + '주 전';
  }

  return pastTimeStr;
});

